import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { Observable } from 'rxjs';
import { ThirdPartsAuthenticationList } from '~modules/thirdparts/common/entities/third-parts-authentication-list.entity';
import { ThirdPartsNextMotionAuthenticationService } from '../../services/third-parts-next-motion-authentication.service';


@Component({
  selector: 'app-next-motion-accounting-entries-api-exporter-configuration',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,

    MatFormFieldModule,
    MatIconModule,
    MatSelectModule,
    MatInputModule
  ],
  templateUrl: './next-motion-ae-api-exporter-configuration.component.html',
  styleUrls: ['./next-motion-ae-api-exporter-configuration.component.scss']
})
export class NextMotionAccountingEntriesApiExporterConfigurationComponent {
  formGroup: FormGroup;

  connectionsOptions$?: Observable<ThirdPartsAuthenticationList[]>;

  constructor(
    readonly fb: FormBuilder,
    protected readonly authenticationService: ThirdPartsNextMotionAuthenticationService,

  ) {
    this.formGroup = fb.group({
      authenticationId: [null, Validators.required],
      clinicId: [null, [Validators.required, Validators.minLength(36), Validators.maxLength(36)]]
    });

    this.connectionsOptions$ = this.authenticationService.list$();
  }
}